import { rest, RestHandler } from 'msw';
import { PATHS } from 'adapters/constants';
import {
  cashInBankResponse
  // errorResponse
} from 'mocks/mockData/cashInBankInterCompanyData';

export const cashInBankInterCompanyHandler: RestHandler[] = [
  rest.get(`${PATHS.getCashInBankAccounts('*', false)}`, (_, res, ctx) =>
    res(ctx.status(200), ctx.json(cashInBankResponse))
  )
];
